"use strict";

exports.__esModule = true;
exports.ChartTypeFieldsSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _LineChartSelector = require("./LineChartSelector");
var _BarChartSelector = require("./BarChartSelector");
var _ScatterChartSelector = require("./ScatterChartSelector");
var _Core = require("../../../../Core");
var _constants = require("../../../constants");
var _PieChartSelector = require("./PieChartSelector");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ChartTypeFieldsSelector = exports.ChartTypeFieldsSelector = function ChartTypeFieldsSelector(props) {
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var elementEditor = props.elementEditor,
    path = props.path,
    itemIndex = props.itemIndex,
    chartItem = props.chartItem,
    _props$blacklistItems = props.blacklistItems,
    blacklistItems = _props$blacklistItems === void 0 ? [] : _props$blacklistItems;
  var chartType = chartItem.chartType;
  var allChartTypes = [_constants.CHART_LINE, _constants.CHART_BAR, _constants.CHART_SCATTER, _constants.CHART_PIE];
  var filteredChartTypes = allChartTypes.filter(function (ch) {
    return !blacklistItems.includes(ch);
  });
  (0, _react.useEffect)(function () {
    if (!chartType) {
      elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].chartType",
          value: el.props.chartItems.props[itemIndex].chartType = _constants.CHART_LINE
        };
      });
    }
  }, [chartItem, elementEditor, path, itemIndex]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "ChartTypeFieldsSelector",
    style: {
      marginBottom: "5px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("ChartTypeFieldsSelector.source.label", "Chart " + (itemIndex + 1))
  }, /*#__PURE__*/_react["default"].createElement(_Core.Selector, {
    dataTestId: "ChartTypeFieldsSelector.chartType.selector",
    items: filteredChartTypes,
    selected: [chartType],
    getKey: function getKey(name) {
      return name;
    },
    renderItemText: function renderItemText(name) {
      return name;
    },
    onSelect: function onSelect(_ref) {
      var selected = _ref[0];
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].chartType",
          value: el.props.chartItems.props[itemIndex].chartType = selected
        };
      });
    }
  })), chartType === _constants.CHART_LINE && /*#__PURE__*/_react["default"].createElement(_LineChartSelector.LineChartSelector, {
    path: path,
    elementEditor: elementEditor,
    chartItem: chartItem,
    itemIndex: itemIndex
  }), chartType === _constants.CHART_BAR && /*#__PURE__*/_react["default"].createElement(_BarChartSelector.BarChartSelector, {
    path: path,
    elementEditor: elementEditor,
    chartItem: chartItem,
    itemIndex: itemIndex
  }), chartType === _constants.CHART_SCATTER && /*#__PURE__*/_react["default"].createElement(_ScatterChartSelector.ScatterChartSelector, {
    path: path,
    elementEditor: elementEditor,
    chartItem: chartItem,
    itemIndex: itemIndex
  }), chartType === _constants.CHART_PIE && /*#__PURE__*/_react["default"].createElement(_PieChartSelector.PieChartSelector, {
    path: path,
    elementEditor: elementEditor,
    chartItem: chartItem,
    itemIndex: itemIndex
  }));
};